import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Three cool things",
  "description": "",
  "published": "2012-01-31T00:00:00.000Z",
  "redirect_from": ["/blog/three-cool-things/swizec/3603"],
  "categories": "Foursquare, Handhelds, IOS, IPhone, Social network, Twitter, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In lieu of a proper blogpost today you get three cool things, because I have to pass two exams an hour apart.`}</p>
    <h2 {...{
      "id": "1-arrivals"
    }}>{`1) Arrivals`}</h2>
    <p><a parentName="p" {...{
        "href": "http://www.iamdanw.com/wrote/arrivals-for-foursquare/"
      }}>{`Arrivals`}</a>{` is an incredibly cool Foursquare app - probably the best I have ever seen. The idea is simple, take your foursquare data, turn your friends into aeroplanes, make an arrivals board like at an airport.`}</p>
    <p>{`And that's pretty much it. The app doesn't do a whole lot, it runs in a browser and I love it because it does a single thing, but does it perfectly and in a cool way.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/606491964bf311e1abb01231381b65e3_710.jpg",
        "alt": "Arrivals for Foursquare",
        "title": "Arrivals for Foursquare"
      }}></img></p>
    <h2 {...{
      "id": "2-design-for-programmers"
    }}>{`2) Design for programmers`}</h2>
    <p><a parentName="p" {...{
        "href": "http://method.ac/"
      }}>{`Method of Action`}</a>{` is something I only discovered last night and haven't had the chance to play around with that much yet. It looks like a very promising way for programmers (people like me) to learn enough about design to hold their own in a conversation with a designer.`}</p>
    <p>{`But more importantly, looks like it will enable us to throw together mockups and to at least understand what designers `}<em parentName="p">{`do`}</em>{`. We love ranting on and on about how none of those stupid `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Luser",
        "title": "Luser"
      }}>{`lusers`}</a>{` understand what a programmer's life is like - time to reciprocate ;)`}</p>
    <p>{`Oh and the `}<a parentName="p" {...{
        "href": "http://type.method.ac/"
      }}>{`Kern`}</a>{`, `}<a parentName="p" {...{
        "href": "http://shape.method.ac/"
      }}>{`Shape`}</a>{` and `}<a parentName="p" {...{
        "href": "http://color.method.ac/"
      }}>{`Color`}</a>{` games are already super fun to play.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/Screen-Shot-2012-01-31-at-11.18.29-AM.png",
        "alt": "Method of Action",
        "title": "Method of Action"
      }}></img></p>
    <h2 {...{
      "id": "3-buffers-ios-app"
    }}>{`3) Buffer's iOS app`}</h2>
    <p>{`My favourite twitter tool `}<a parentName="p" {...{
        "href": "http://blog.bufferapp.com/the-complete-guide-to-the-brand-new-buffer-iphone-app"
      }}>{`Buffer has now got an iPhone app`}</a>{`. If you don't know about Buffer yet, shame on you! It's only the tool that played a great role in increasing my blog traffic baseline by roughly 1000% last year. Yes, that's a thousand percent.`}</p>
    <p>{`Diminishing returns aside, it's still a very powerful tool.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/IMG_01763.png",
        "alt": "Mine was just emptied so the screenshot was lame",
        "title": "Mine was just emptied so the screenshot was lame"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mashable.com/2012/01/30/arrivals-for-foursquare-displays-check-ins-on-old-style-airport-board/"
        }}>{`Arrivals for Foursquare Displays Check-ins on Old-Style Airport Board`}</a>{` (mashable.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.ilounge.com/index.php/news/comments/foursquare-update-introduces-radar-for-ios-5/"
        }}>{`News: Foursquare update introduces Radar for iOS 5`}</a>{` (ilounge.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mashable.com/2012/01/30/impending-clear-interview/"
        }}>{`Clear To Do App Has Some Surprising Design Inspirations`}</a>{` (mashable.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.lockergnome.com/social/2011/12/05/foursquare-is-a-waste-of-time/"
        }}>{`Foursquare is a Waste of Time`}</a>{` (lockergnome.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7c028505-7458-4a31-8f52-c2ddd33306f7",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      